const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const toMs = (value) => {
  if (value == null || value === '') return null;
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value > 1e12 ? value : value < 1e11 ? value * 1000 : value;
  }
  const ms = Date.parse(value);
  return Number.isFinite(ms) ? ms : null;
};

/** «5 ч 48 мин», «12 мин», «2 д 5 ч» — для «Недоступен …». */
export const formatDuration = (from, nowMs = Date.now()) => {
  const start = toMs(from);
  if (start == null) return null;
  const elapsed = Math.max(0, nowMs - start);
  const days = Math.floor(elapsed / DAY);
  const hours = Math.floor((elapsed % DAY) / HOUR);
  const minutes = Math.floor((elapsed % HOUR) / MINUTE);
  if (days > 0) return hours > 0 ? `${days} д ${hours} ч` : `${days} д`;
  if (hours > 0) return minutes > 0 ? `${hours} ч ${minutes} мин` : `${hours} ч`;
  if (minutes < 1) return 'меньше минуты';
  return `${minutes} мин`;
};

/** Секунды времени работы регистратора: «2 д 3 ч 39 мин», «5 ч 48 мин», «9 мин». */
export const formatUptimeSeconds = (seconds) => {
  const total = Number(seconds);
  if (!Number.isFinite(total) || total < 0) return null;
  const whole = Math.floor(total);
  const days = Math.floor(whole / 86400);
  const hours = Math.floor((whole % 86400) / 3600);
  const minutes = Math.floor((whole % 3600) / 60);
  const parts = [];
  if (days > 0) parts.push(`${days} д`);
  if (hours > 0) parts.push(`${hours} ч`);
  if (minutes > 0) parts.push(`${minutes} мин`);
  if (parts.length === 0) return 'меньше минуты';
  return parts.join(' ');
};

/** «04.10 12:09» в Asia/Almaty. */
export const formatStampAlmaty = (from) => {
  const ms = toMs(from);
  if (ms == null) return null;
  try {
    const parts = new Intl.DateTimeFormat('ru-KZ', {
      timeZone: 'Asia/Almaty',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date(ms));
    const get = (type) => parts.find((part) => part.type === type)?.value;
    const day = get('day');
    const month = get('month');
    const hour = get('hour');
    const minute = get('minute');
    if (!day || !month || !hour || !minute) return null;
    return `${day}.${month} ${hour}:${minute}`;
  } catch {
    return null;
  }
};

const almatyParts = (from) => {
  const ms = toMs(from);
  if (ms == null) return null;
  try {
    const parts = new Intl.DateTimeFormat('ru-KZ', {
      timeZone: 'Asia/Almaty',
      year: 'numeric',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date(ms));
    const get = (type) => parts.find((part) => part.type === type)?.value;
    const day = get('day');
    const month = get('month');
    const year = get('year');
    const hour = get('hour');
    const minute = get('minute');
    if (!day || !month || !hour || !minute) return null;
    return { day, month, year, hour, minute };
  } catch {
    return null;
  }
};

/** Тултип: «04.10.2026, 18:42». */
export const formatChartDateTime = (from) => {
  const p = almatyParts(from);
  if (!p) return null;
  return `${p.day}.${p.month}.${p.year}, ${p.hour}:${p.minute}`;
};

/** Ось X: время или [дата, время] на длинном диапазоне. */
export const formatChartTick = (from, { withDate } = {}) => {
  const p = almatyParts(from);
  if (!p) return '';
  const clock = `${p.hour}:${p.minute}`;
  if (!withDate) return clock;
  return [`${p.day}.${p.month}`, clock];
};
